import { AdminUsersRole } from 'stores/users/types';

export const rolesOptions: Exclude<AdminUsersRole, 'super-admin'>[] = [
  'admin',
  'points-and-polygons-manager',
  'points-manager',
  'polygons-manager',
  'requests-manager',
];
